import type { Chain } from '../../chain'

type GetCurrentFinalizedBlockNumberParameters = {
  chain: Chain
  timeout?: number
}

/**
 * Polkadot RPC から現在の finalized block number を取得する。
 * @param params - 対象 chain と RPC timeout
 * @returns 現在 finalized 済みの block number
 */
export const getCurrentFinalizedBlockNumber = async ({
  chain,
  timeout,
}: GetCurrentFinalizedBlockNumberParameters): Promise<number> => {
  const blockNumber = await chain.client.call(async (api) => {
    const finalizedHash = await api.rpc.chain.getFinalizedHead()
    const header = await api.rpc.chain.getHeader(finalizedHash)
    return header.number.toNumber()
  }, timeout)

  if (!Number.isSafeInteger(blockNumber) || blockNumber < 0) {
    throw new Error(`Invalid finalized block number: ${blockNumber}`)
  }

  return blockNumber
}
